module.exports = __webpack_public_path__ + "static/media/p_5.4b442eec.jpg";